<template>
  <div class="statistics-sellers">
    <div v-if="!sellersStatistics.length" class="alert alert-info">
      Aucun résultat à afficher pour le moment.
    </div>

    <div v-else class="table-responsive">
      <table class="table table-striped table-hover align-middle">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Référence</th>
            <th scope="col">Nom</th>
            <th scope="col">Clients</th>
            <th scope="col">Ventes</th>
            <th scope="col">Qté vendue</th>
            <th scope="col">Montant TTC</th>
            <th scope="col">Ventes du jour</th>
            <th scope="col">Qté du jour</th>
            <th scope="col">Montant du jour</th>
            <th scope="col">Paiements</th>
            <th scope="col">Paiements du jour</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(seller, index) in sellersStatistics"
            :key="seller.reference"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ seller.reference }}</td>
            <td>{{ seller.fullName }}</td>
            <td>{{ formatInteger(seller.totalCustomers) }}</td>
            <td>{{ formatInteger(seller.totalSales) }}</td>
            <td>{{ formatQuantity(seller.totalSalesQuantity) }}</td>
            <td>{{ formatAmount(seller.totalSalesPriceTTC) }}</td>
            <td>{{ formatInteger(seller.todaySales) }}</td>
            <td>{{ formatQuantity(seller.todaySalesQuantity) }}</td>
            <td>{{ formatAmount(seller.todaySalesPriceTTC) }}</td>
            <td>{{ formatAmount(seller.totalPaymentsAmount) }}</td>
            <td>{{ formatAmount(seller.todayPaymentsAmount) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("statistic", {
      sellersStatistics: "getSellersStatistics",
    }),
  },
  mounted() {
    this.$store.dispatch("statistic/fetchSellersStatistics");
  },
  methods: {
    formatInteger(value) {
      const number = Number(value || 0);
      return Number.isNaN(number)
        ? "-"
        : new Intl.NumberFormat("fr-FR").format(number);
    },
    formatQuantity(value) {
      const number = Number.parseFloat(value || 0);
      return Number.isNaN(number)
        ? "-"
        : new Intl.NumberFormat("fr-FR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(number);
    },
    formatAmount(value) {
      const number = Number.parseFloat(value || 0);
      return Number.isNaN(number)
        ? "-"
        : new Intl.NumberFormat("fr-FR", {
            style: "currency",
            currency: "MAD",
            minimumFractionDigits: 2,
          }).format(number);
    },
  },
};
</script>

<style scoped>
.statistics-sellers .table-responsive {
  max-height: 70vh;
}
</style>
